'use es6';

import { debounce, pick } from 'underscore';
import * as actions from 'DesignData/actions/ActionTypes';
import { saveByPath } from 'DesignData/actions/CustomWidgetBuffers';
import { DEBOUNCE_DELAY } from 'DesignData/constants/Autosave';
const AUTOSAVE_ACTIONS = pick(actions, ['CUSTOM_WIDGET_FIELD_CREATE', 'CUSTOM_WIDGET_FIELD_CREATE_GROUP', 'CUSTOM_WIDGET_FIELD_CLONE', 'CUSTOM_WIDGET_FIELD_DELETE', 'CUSTOM_WIDGET_FIELD_EDIT', 'CUSTOM_WIDGET_FIELD_MOVE', 'CUSTOM_WIDGET_REVERT', 'CUSTOM_WIDGET_SOURCE_UPDATE', 'CUSTOM_WIDGET_EDIT_UNDO', 'CUSTOM_WIDGET_EDIT_REDO', 'CUSTOM_WIDGET_BUFFER_ADD_ASSET', 'CUSTOM_WIDGET_BUFFER_UPDATE', 'CUSTOM_WIDGET_GLOBAL_CONTENT_EDIT', 'CUSTOM_WIDGET_BUFFER_TRANSLATIONS_OPT_IN', 'CUSTOM_WIDGET_BUFFER_ADD_LANGUAGE', 'CUSTOM_WIDGET_BUFFER_DELETE_LANGUAGE', 'CUSTOM_WIDGET_BUFFER_UPDATE_LANGUAGE', 'CUSTOM_WIDGET_BUFFER_CHANGE_SOURCE_LANGUAGE', 'CUSTOM_WIDGET_BUFFER_UPDATE_MESSAGES', 'CUSTOM_WIDGET_BUFFER_UPDATE_TRANSLATION', 'CUSTOM_WIDGET_BUFFER_REPLACE_TRANSLATION', 'CUSTOM_WIDGET_BUFFER_ADD_SMART_RULE', 'CUSTOM_WIDGET_BUFFER_REMOVE_SMART_RULE', 'CUSTOM_WIDGET_BUFFER_REMOVE_SMART_RULES', 'CUSTOM_WIDGET_BUFFER_EDIT_SMART_RULE', 'CUSTOM_WIDGET_BUFFER_EDIT_SMART_RULES_ORDER', 'CUSTOM_WIDGET_BUFFER_MAKE_SMART', 'CUSTOM_WIDGET_BUFFERS_UPDATE_SMART_RULES']);

function saveCustomWidget(dispatch, customWidgetId) {
  dispatch(saveByPath(customWidgetId));
}

const debouncedSave = debounce(saveCustomWidget, DEBOUNCE_DELAY);
export default (({
  dispatch
}) => next => action => {
  const result = next(action);
  const {
    customWidgetId
  } = result;

  if (customWidgetId && AUTOSAVE_ACTIONS[result.type]) {
    debouncedSave(dispatch, customWidgetId);
  }

  return result;
});